import api from '../api'

const baseUrl = '/academy/api/AdminPackage'

const dadbanFrequentlyAskedQuestionsProvider = {
  getQuestions(id) {
    return api.get(`${baseUrl}/FrequentlyAskedQuestions/${id}`)
  },

  addFrequentlyAskedQuestions(params) {
    return api.post(`${baseUrl}/FrequentlyAskedQuestions`, params)
  },
}

export default dadbanFrequentlyAskedQuestionsProvider
